<template lang="pug">
#modal-documentos-analise(:style='{ padding : "15px"}')
    .documentos-content(v-if="documentos.length > 0")
        .linha(v-if="documentoComDescricao")
            b.coluna Descrição dos documentos:
        .linha(v-if="documentoComDescricao")
            .coluna
                span {{ documentoComDescricao.descricao }}
        .linha
            .coluna
                grid-table-component(:headers='headerModalDocumentos', :data='documentos', :is-paginated='false')
                    template(v-slot:acao='{ item }')
                        chip-component(
                            icon='mdi-download',
                            color='var(--primary-black)',
                            background-color='var(--primary-transparent)',
                            :style='{ cursor : "pointer"}',
                            @click.native='downloadDocumento(item)'
                        )
    .documentos-content(v-else)
        .linha
            .coluna
                span Não possui documentos registrados!
</template>

<script>
import { downloadDocumentoById } from '@/services/tipo-documento.service.js'
import { downloadDocumento } from '@/services/processo.service.js'

export default {
    name: 'AnaliseModalDocumentos',

    props: {
        etapa: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            headerModalDocumentos: [
                { text: 'Nome', field: 'nome' },
                { text: 'Ação', field: 'acao' },
            ],
            documentos: [],
        }
    },

    computed: {
        documentoComDescricao() {
            return this.documentos.find(d =>
                d.descricao &&
                d.descricao.trim() !== 'e' &&
                d.descricao.trim().length > 1
            );
        }
    },

    mounted() {
        let docs = [];

        if (this.etapa?.documentos && this.etapa?.documentos.length > 0) {
            docs = [...this.etapa.documentos];
        } else if (this.etapa?.documentosSolicitados && this.etapa?.documentosSolicitados.length > 0) {
            docs = [...this.etapa.documentosSolicitados];
        }

        if (this.etapa?.caminhoArmazenamentoArquivoAutoInfracao) {
            docs = docs.filter(d => d.nome !== "Auto de infração ambiental");
        }

        this.documentos = docs.map(d => ({ ...d, acao: 'acao' }));

        // Adicionar arquivo de auto de infração se houver caminho
        if (this.etapa?.caminhoArmazenamentoArquivoAutoInfracao?.trim()) {
            const nomeArquivo = this.etapa.caminhoArmazenamentoArquivoAutoInfracao.split('/').pop() || 'Auto_de_infracao.pdf';

            this.documentos.push({
                id: 'auto_infracao',
                nome: nomeArquivo,
                caminho: this.etapa.caminhoArmazenamentoArquivoAutoInfracao,
                acao: 'acao',
                isCaminho: true
            });
        }

        // Adicionar arquivo de embargo se houver caminho
        if (this.etapa?.caminhoArmazenamentoArquivoEmbargo?.trim()) {
            const nomeArquivo = this.etapa.caminhoArmazenamentoArquivoEmbargo.split('/').pop() || 'Embargo.pdf';

            this.documentos.push({
                id: 'arquivo_embargo',
                nome: nomeArquivo,
                caminho: this.etapa.caminhoArmazenamentoArquivoEmbargo,
                acao: 'acao',
                isCaminho: true
            });
        }
    },

    methods: {
        async downloadDocumento(item) {
            try {
                let response;

                if (item.isCaminho && item.caminho) {
                    response = await downloadDocumento(item.caminho);
                } else {
                    response = await downloadDocumentoById(item.id);
                }

                const file = window.URL.createObjectURL(new Blob([response.data]));
                const docUrl = document.createElement('a');
                docUrl.href = file;
                docUrl.setAttribute('download', item.nome);
                document.body.appendChild(docUrl);
                docUrl.click();
                document.body.removeChild(docUrl);
            } catch (error) {
                this.$toast({
                    message: 'Erro ao realizar o download do documento.',
                    type: 'error'
                });
            }
        }
    }
}
</script>